import { CircleDot, Mic, AudioLines } from "lucide-react";
import { motion } from "framer-motion";

const STEPS = [
  { Icon: CircleDot, title: "Press.", text: "One button starts the conversation.", note: "On your wrist" },
  { Icon: Mic, title: "Speak.", text: "Ask a question in your own words.", note: "In your own words" },
  { Icon: AudioLines, title: "Hear.", text: "Pulse One answers back, out loud.", note: "In your chosen voice" },
];

export const SignalObject = () => (
  <section id="object" data-testid="signal-object" className="signal-object signal-chapter">
    <div className="signal-container">
      <div className="signal-section-intro">
        <div>
          <h2 className="signal-eyebrow" data-testid="signal-object-label">The bracelet</h2>
          <p className="signal-display" data-testid="signal-object-statement">One button.<br />A natural conversation.</p>
        </div>
        <p className="signal-intro-note" data-testid="signal-object-description">An AI voice assistant, built into a bracelet.<br />Not another app to open. Just a question to ask.</p>
      </div>
      <div className="signal-interaction-steps" data-testid="signal-transmission-log">
        {STEPS.map(({ Icon, title, text, note }, i) => (
          <motion.div key={title} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.1 }} data-testid={`signal-object-step-${i}`}>
            <Icon size={29} strokeWidth={1.25} aria-hidden="true" />
            <h3>{title}</h3><p>{text}</p><span>{note}</span>
          </motion.div>
        ))}
      </div>
      <div className="signal-object-essentials" data-testid="signal-spec-table">
        <p data-testid="signal-spec-connection"><span>Connection</span> Built-in cellular (eSIM) + Wi-Fi</p>
        <p data-testid="signal-spec-app"><span>Mobile app</span> Optional · setup, settings & firmware</p>
        <p data-testid="signal-spec-reveal">Final specifications at the design reveal.</p>
      </div>
    </div>
  </section>
);